import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit
} from '@angular/core';
import { ExecuteStatementOutput } from '@aws-sdk/client-dynamodb';

import { DynamoDbService } from '../../services/dynamodb.service';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarChartComponent implements OnInit {
  #chart!: Chart;
  #ddb = inject(DynamoDbService);
  #cdr = inject(ChangeDetectorRef);
  isFullScreen = false;

  constructor() {
    Chart.register(...registerables, ChartDataLabels);
  }

  ngOnInit(): void {
    this.#ddb.fetchAccountTable().subscribe({
      next: (data) => {
        this.createChart(data.Items);
      },
      error: (err) => console.error('Error fetching team scores:', err)
    });
    document.addEventListener('fullscreenchange', () => {
      this.isFullScreen = !!document.fullscreenElement;
      if (!this.isFullScreen) {
        document.body.style.overflow = 'auto';
      }
      this.#cdr.markForCheck();
    });
  }

  toggleFullScreen() {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
        document.body.style.overflow = 'hidden';
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        document.body.style.overflow = 'auto';
      }
    }
  }
  createChart(data: ExecuteStatementOutput['Items']) {
    const labels = data!.map(item => item['TeamName']?.S || '未定義');
    const scores = data!.map(item => Number(item['TotalScore']?.N) || 0);

    const ctx = document.getElementById('barChart') as HTMLCanvasElement;
    this.#chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'CP',
          data: scores,
          backgroundColor: 'rgba(75, 192, 192, 0.8)',
          borderRadius: 8,
          borderSkipped: false
        }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          // title: {
          //   display: true,
          //   text: '結果発表',
          //   font: {
          //     size: 60
          //   },
          //   padding: {
          //     top: 0,
          //     bottom: 30
          //   }
          // },
          datalabels: {
            anchor: 'end',
            align: 'top',
            padding: 15,
            font: {
              size: 40
            },
            formatter: (value, context) => {
              return context.chart.data.labels![context.dataIndex];
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              display: false
            },
            grid: {
              display: false
            },
            border: {
              display: false
            }
          },
          x: {
            ticks: {
              display: true,
              font: {
                size: 55
              },
              padding: 15,
              callback: function (value, index) {
                return this.chart.data.datasets[0].data[index] + '  CP';
              }
            },
            grid: {
              display: false
            },
            border: {
              display: false
            }
          },
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 150,
            bottom: 100
          }
        }
      }
    });
  }
}